import script from "./ToolTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolTip.vue?vue&type=script&setup=true&lang=ts"

import "./ToolTip.vue?vue&type=style&index=0&id=3c8cf7dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c8cf7dc"]])

export default __exports__